




































































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { ConversionClaimAccountRequest } from "@/shared/types";
import moment from "moment";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    Input,
    Checkbox,
    Button,
    LoginWrapper,
    GenericLoadingSpinner
  }
})
export default class ConversionClaimAccount extends Vue {
  enrollmentStore = useEnrollmentStore();
  portalCustomizationStore = usePortalCustomizationStore();

  $validator: Validator;

  isSubmitting = false;

  email = "";
  dateOfBirth = "";
  ssn = "";
  successfulSubmission = false;

  created () {
    if (!this.enrollmentStore.previouslyEnteredPii) {
      return;
    }

    this.ssn = this.enrollmentStore.previouslyEnteredPii.ssn || "";
    const dobMoment = moment(this.enrollmentStore.previouslyEnteredPii.dateOfBirth, "YYYY-MM-DD");
    this.dateOfBirth = dobMoment.isValid() ? dobMoment.format("MM/DD/YYYY") : "";
    this.email = this.enrollmentStore.previouslyEnteredPii.emailAddress || "";
    this.enrollmentStore.clearPreviouslyEnteredPii();
  }

  get isSubmitButtonDisabled (): boolean {
    return (this.$validator.errors.any() || this.isSubmitting);
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      const conversionClaimAccountRequest: ConversionClaimAccountRequest = {
        email: this.email,
        dateOfBirth: moment(this.dateOfBirth).format("YYYY-MM-DD"),
        ssn: this.ssn
      };

      this.enrollmentStore.conversionClaimAccount(conversionClaimAccountRequest)
          .then(() => {
            this.isSubmitting = false;
            this.successfulSubmission = true;
          })
          .catch(() => {
            this.isSubmitting = false;
            this.successfulSubmission = false;
          });
    });
  }

  get supportPhoneNumber () {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get hrefSupportPhoneNumber () {
    return `tel:${this.supportPhoneNumber}`;
  }
}
